// GSAP 플러그인을 한 곳에서 등록하고 공용 미디어 조건을 내보내는 모듈
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { TextPlugin } from 'gsap/TextPlugin';
import { useGSAP } from '@gsap/react';
import { useEffect } from 'react';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, TextPlugin, useGSAP);

// gsap.matchMedia() 조건. motionOk 가 false 면 접근성 설정(prefers-reduced-motion)으로 애니메이션을 생략한다.
export const MEDIA = {
    motionOk: '(prefers-reduced-motion: no-preference)',
    mobile: '(max-width: 745px)',
    desktop: '(min-width: 746px)'
};

export { gsap, ScrollTrigger, useGSAP };

/**
 * 이미지(특히 lazy 이미지)가 로드되어 레이아웃이 바뀌면 ScrollTrigger 위치를 다시 계산한다.
 * 앱 루트 레이아웃에서 한 번만 호출한다.
 */
export function useRefreshScrollTriggerOnImageLoad() {
    useEffect(() => {
        let timer: ReturnType<typeof setTimeout> | undefined;

        const onLoad = (event: Event) => {
            if (!(event.target instanceof HTMLImageElement)) return;
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => ScrollTrigger.refresh(), 100);
        };

        // load 이벤트는 버블링되지 않으므로 캡처 단계에서 받는다.
        document.addEventListener('load', onLoad, true);

        return () => {
            document.removeEventListener('load', onLoad, true);
            if (timer) clearTimeout(timer);
        };
    }, []);
}
